/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { IBillerConfiguration } from 'types/billerConfiguration';
import { IRetailer } from '../types/retailer';

export const getRetailers = (state: any): IRetailer[] => state.retailers.retailers;
export const getRetailersLoadStatus = (state: any): string => state.retailers.status;
export const getBillerConfiguration = (state: any): IBillerConfiguration => state.billerConfiguration;